import { Directive, OnDestroy } from "@angular/core";

// libs
import { Subject } from "rxjs";
import { skip } from "rxjs/operators";
import { environment } from "../environments/environment";
import { User } from "../models";
import { UserService } from "../services/user.service";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
@Directive()
export abstract class BaseComponent implements OnDestroy {
  // Initialize user to false to match the BehaviorSubject's initial value and prevent
  // NG0100 ExpressionChangedAfterItHasBeenCheckedError. Using 'any' cast because the
  // property is typed as User but can legitimately be false when not logged in.
  public user: User = false as any;
  public destroy$: Subject<any> = new Subject();
  public themeImage: string;
  public env = environment;

  constructor(public userService: UserService) {
    this.userService.themeImg$.pipe(takeUntilDestroyed()).subscribe((result) => {
      this.themeImage = result;
    });

    // Synchronize with current user state - prefer the synchronous getter value if available,
    // otherwise use the BehaviorSubject's current value (which is 'false' when not logged in)
    const currentUser = this.userService.user;
    this.user = currentUser !== undefined ? currentUser : this.userService.user$.getValue();

    this.userService.user$.pipe(skip(1), takeUntilDestroyed()).subscribe((result) => {
      this.user = result;
    });
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
